import { render, staticRenderFns } from "./editorCom.vue?vue&type=template&id=0c25b2e0&scoped=true&"
import script from "./editorCom.vue?vue&type=script&lang=js&"
export * from "./editorCom.vue?vue&type=script&lang=js&"
import style0 from "./editorCom.vue?vue&type=style&index=0&id=0c25b2e0&lang=scss&scoped=true&"
import style1 from "./editorCom.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c25b2e0",
  null
  
)

component.options.__file = "editorCom.vue"
export default component.exports